import React from 'react'
const HorseNumber = ctx => {
  return <div className="columns is-mobile">
      <div className="column is-one-fifth has-text-weight-bold">
        {ctx.number}
    </div>
      <div className="column">
       <img className="silkImage" src={ctx.colorUrl} alt="silks" />
      </div>
    <style jsx>{`
      .silkImage {
        width:70px;
      }
    `}</style>
  </div>
}

export default HorseNumber
